module.exports = __webpack_public_path__ + "img/footprint.2cee7b0f.svg";